import { render, staticRenderFns } from "./AdminMensajeria.vue?vue&type=template&id=e60c6e9e&scoped=true&"
import script from "./AdminMensajeria.vue?vue&type=script&lang=js&"
export * from "./AdminMensajeria.vue?vue&type=script&lang=js&"
import style0 from "./AdminMensajeria.vue?vue&type=style&index=0&id=e60c6e9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60c6e9e",
  null
  
)

export default component.exports